<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>投诉管理</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item label='投诉内容'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入投诉内容"
            >
              <el-button
                slot="append"
                v-on:click="handleSearch"
              >搜索</el-button>
            </el-input>
            <!-- <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出订单</el-button> -->
            <!-- <el-button
              @click="batchIn"
              type="success"
              size="small"
            >批量发货</el-button> -->
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="发布时间">
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="startTime">
                      <el-date-picker
                        type="date"
                        placeholder="选择开始日期"
                        v-model="filters.startTime"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="1">
                    <div style="display: inline-block;width:100%;text-align:center">-</div>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item prop="endTime">
                      <el-date-picker
                        type="date"
                        placeholder="选择结束日期"
                        v-model="filters.endTime"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-form-item>
            </el-col>
            <el-col
              :offset="1"
              :span="7"
            >
              <el-form-item label="订单状态">
                <el-select
                  v-model="filters.status"
                  clearable
                >
                  <el-option
                    label="待处理"
                    value="1"
                  ></el-option>
                  <el-option
                    label="处理中"
                    value="2"
                  ></el-option>
                  <el-option
                    label="待评价（处理完成）"
                    value="3"
                  ></el-option>
                  <el-option
                    label="已驳回"
                    value="4"
                  ></el-option>
                  <el-option
                    label="已结束"
                    value="5"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="发布人信息:">
                <el-input
                  style="width: 200px;"
                  v-model="filters.userInfo"
                  placeholder="请输入发布人手机号或姓名"
                >
                </el-input>

              </el-form-item>
            </el-col>
            <el-col :span="8">

              <el-form-item label="被投诉人信息:">
                <el-input
                  style="width: 200px;"
                  v-model="filters.goodName"
                  placeholder="请输入被投诉人手机号或姓名"
                >
                </el-input>

              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item
                v-if="provinceList != null"
                label="所在省"
                prop="province"
              >
                <el-select
                  clearable
                  v-model="filters.province"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="option in provinceOptions"
                    :value="option"
                    :key='option'
                    :label="option"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          v-loading='tableDataLoading'
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="long_code"
            label="投诉编号"
          >
          </el-table-column>

          <el-table-column
            prop="username"
            label="发布人姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="发布人手机号"
          >
          </el-table-column>

          <el-table-column
            prop="commend"
            label="投诉内容"
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            prop="detail_pic"
            label="投诉图片"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.detail_pic != null"
                @click="showPicDialog(scope.row.detail_pic)"
                type="text"
              >查看</el-button>
            </template>
          </el-table-column>

          <el-table-column
            prop="up_name"
            label="被投诉人姓名"
          >
          </el-table-column>

          <el-table-column
            prop="up_tel"
            label="被投诉对象手机号"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
          >
          </el-table-column>

          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="showDetail(scope.row)"
                type="text"
              >查看</el-button>
              <el-button
                v-if="scope.row.status==1 && scope.row.area_id == null && hasPower('20031991991')"
                @click="showChuDialog(scope.row)"
                type="text"
              >处理</el-button>
              <el-button
                v-if="scope.row.status==7 && hasPower('20031991991')"
                @click="showChuDialog2(scope.row)"
                type="text"
              >分配</el-button>
              <el-button
                v-if="scope.row.status==2 && hasPower('20031991991')"
                @click="showBoDialog(scope.row)"
                type="text"
              >驳回</el-button>
              <el-button
                v-if="scope.row.status==2 && hasPower('20031991991')"
                @click="upHouseStatus(scope.row, 3)"
                type="text"
              >通过</el-button>

            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


    <el-dialog
      title="分配"
      :visible.sync="dialogChuVisible2"
      width="25%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form2"
        ref="form2"
        :rules="addFormRule2"
      >
        <el-form-item
          label="选择分配对象"
          prop='status'
        >
          <el-select
                  v-model="form2.status"
                  clearable
                >
                  <el-option
                    label="平台"
                    value="1"
                  ></el-option>
                  <el-option
                    label="上级"
                    value="2"
                  ></el-option>
                  <el-option
                    label="当地服务商"
                    value="3"
                  ></el-option>
                 
                </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="throwCom3()"
            :loading="editLoading2"
          >处理</el-button>
          <el-button @click="dialogChuVisible2 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="处理投诉"
      :visible.sync="dialogChuVisible"
      width="25%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule1"
      >
        <el-form-item
          label="描述"
          prop='words'
        >
          <el-input
            v-model="form.words"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="throwCom1()"
            :loading="editLoading"
          >处理</el-button>
          <el-button @click="dialogChuVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="审核投诉"
      :visible.sync="dialogEditVisible"
      width="25%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="扣除保证金金额"
          prop='outMoney'
        >
          <el-input
            oninput="value=value.replace(/[^0-9.]/g,'')"
            v-model="form.outMoney"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="throwCom()"
            :loading="addLoading"
          >完成</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="查看投诉图片"
      :visible.sync="showPicLoading"
      width="40%"
    >
      <div class="shop-pic1">
        <img
          style="width:100%"
          v-for="url in detailPics"
          :key="url"
          :src="url"
        />
      </div>
    </el-dialog>


    <el-dialog
      title="驳回投诉"
      :visible.sync="dialogBoVisible"
      width="25%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule1"
      >
        <el-form-item
          label="驳回理由"
          prop='words'
        >
          <el-input
            v-model="form.words"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="throwCom2()"
            :loading="boLoading"
          >驳回</el-button>
          <el-button @click="dialogBoVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="查看投诉图片"
      :visible.sync="showPicLoading"
      width="40%"
    >
      <div class="shop-pic1">
        <img
          style="width:100%"
          v-for="url in detailPics"
          :key="url"
          :src="url"
        />
      </div>
    </el-dialog>

    <el-dialog
      title="查看操作记录"
      :visible.sync="showListLoading"
      width="40%"
    >
      <el-table
        :data="tableDataList"
        v-loading='listDataLoading'
        style="width: 100%"
        :header-cell-class-name='objectSpanMethod'
      >

        <el-table-column
          prop="username"
          label="操作人"
        >
        </el-table-column>

        <el-table-column
            label="头像"
            prop="userHead"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.userHead"
                style="width:50px;"
              >
            </template>
          </el-table-column>

        <el-table-column
          prop="commend"
          label="内容"
        >
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="操作时间"
        >
        </el-table-column>

      </el-table>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import API from "../api/api_user";
import { dateFunc } from "../dateFunc";
var _ = require("lodash");
export default {
  name: "complainList",
  created() {},

  data() {
    return {
      provinceOptions:[],
      dialogChuVisible2:false,
      provinceList:null,
      showListLoading: false,
      tableDataList: [],
      listDataLoading: false,
      dialogEditVisible: false,
      addExcelSnedLoading: false,
      errMsg: null,
      dialogBatchInVisible: false,
      batchInPostLoading: false,
      tableDataLoading: false,
      searchUserId: null,
      tableData1: [],
      dialogBoVisible:false,
      editLoading2:false,
      dialogChuVisible2:false,
      form2:{
        id:null,
        status:null
      },
      boLoading:false,
      addFormRule2: {
        status: [
          {
            required: true,
            message: "请选择分配对象",
            trigger: "blur"
          }
        ]
      },
      addFormRule: {
        outMoney: [
          {
            required: true,
            message: "请填写扣款金额，如果不扣就填0",
            trigger: "blur"
          }
        ]
      },
      addFormRule1: {

      },
      showPicLoading: false,
      addLoading: false,
      editLoading:false,
      dialogChuVisible:false,
      form: {
        outMoney: 0,
        id: null,
        status: null,
        words:null
      },
      file: null,
      filters: {
        address: null,
        title: null,
        status: null,
        startTime: null,
        endTime: null,
        status: null,
        userInfo: null,
        goodName: null
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailPics: [],
      tableHeight:null
    };
  },
  mounted() {
    this.provinceList  = localStorage.getItem("provinceList");
    if (this.provinceList && this.provinceList != null && this.provinceList != '')
    {
      this.provinceOptions = this.provinceList.split(',');
    }
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    showDetail(row) {
      var that = this;
      API.complain_detail({
        token: localStorage.getItem("api_token"),
        id:row.id
      })
        .then(
          function(result) {
            if (result.key == 1000) {
              for (var i=0;i<result.result.data.details.length; i++)
              {
                result.result.data.details[i].createTime = dateFunc.formatTime(new Date(result.result.data.details[i].createTime));
              }
              that.tableDataList = result.result.data.details;
              that.showListLoading = true;
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
            that.addLoading = false;
          },
          function(err) {
            that.addLoading = false;
            console.error(err);
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.addLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    showPicDialog(pics) {
      this.detailPics = pics.split(",");
      this.showPicLoading = true;
    },

    showBoDialog(row) {
      this.form.words = null;
      this.form.id = row.id;
      this.form.status = 2;
      this.dialogBoVisible = true;
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    throwCom2() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.boLoading = true;
          API.status_complain(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "操作成功",
                    duration: 1500
                  });
                  that.dialogBoVisible = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.boLoading = false;
              },
              function(err) {
                that.boLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },

    showChuDialog2(row) {
      this.form2.status = null;
      this.form2.id = row.id;
      this.dialogChuVisible2 = true;
    },

    showChuDialog(row) {
      this.form.words = null;
      this.form.id = row.id;
      this.form.status = 1;
      this.dialogChuVisible = true;
    },

    throwCom3() {
      let that = this;
      that.$refs["form2"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form2);
          para.token = localStorage.getItem("api_token");
          that.editLoading2 = true;
          API.give_complain(para)
            .then(
              function(result) {
                that.$refs["form2"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "操作成功",
                    duration: 1500
                  });
                  that.dialogChuVisible2 = false;

                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.editLoading2 = false;
              },
              function(err) {
                that.editLoading2 = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading2 = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },

    throwCom1() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.editLoading = true;
          API.status_complain(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "操作成功",
                    duration: 1500
                  });
                  that.dialogChuVisible = false;

                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.editLoading = false;
              },
              function(err) {
                that.editLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    throwCom() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.status_complain(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "操作成功",
                    duration: 1500
                  });
                  that.dialogEditVisible = false;

                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.addLoading = false;
              },
              function(err) {
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
    batchIn() {
      this.form.excelFile = null;
      this.file = null;
      this.dialogBatchInVisible = true;
    },
    batchInPost(event) {
      event.preventDefault();
      var that = this;
      if (this.file == null) {
        that.$message.error({
          showClose: true,
          message: "请先上传需要导入的excel",
          duration: 2000
        });
        return;
      } else {
        that.addExcelSnedLoading = true;
        that.batchInPostLoading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        var ss = this.file.name
          .substr(this.file.name.lastIndexOf("."))
          .toUpperCase(); //得到的是后缀名,且转换为大写
        if (ss == ".XLS") {
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };

          API.import_car_info(formData, config)
            .then(
              function(result) {
                that.batchInPostLoading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (result.result.list.length == 0) {
                    that.dialogBatchInVisible = false;
                    that.$message.success({
                      showClose: true,
                      message: "发货成功",
                      duration: 1500
                    });
                    that.search();
                  } else {
                    that.errMsg = result.result.list;
                  }
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "请求失败，请检查文件格式和内容是否符合要求",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.batchInPostLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.batchInPostLoading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          this.errMsg = ["格式错误"];
          return;
        }
      }
    },

    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/item_order_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.title) {
        url = url + "&keyword=" + that.filters.title;
      }
      if (that.filters.goodName) {
        url = url + "&bInfo=" + that.filters.goodName;
      }
      if (that.filters.userInfo) {
        url = url + "&fInfo=" + that.filters.userInfo;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.address) {
        url = url + "&address=" + that.filters.address;
      }
      top.location.href = url;
    },

    formatterStatus(row, column) {
      if (row.status == 1) {
        return "待处理";
      } else if (row.status == 2) {
        return "处理中";
      } else if (row.status == 3) {
        return "待评价（处理完成）";
      } else if (row.status == 4) {
        return "已驳回";
      } else if (row.status == 5) {
        return "已结束";
      } else if (row.status == 7) {
        return "待分配";
      }
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },
    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm(
          "确定后用户就会收到处理中的通知",
          "确认开始处理这个投诉了吗",
          { type: "info" }
        )
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 1
            };
            API.status_complain(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "标记处理成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
        this.form.outMoney = 0;
        this.form.id = row.id;
        this.form.status = 3;
        this.dialogEditVisible = true;
      } else if (status == 4) {
        let that = this;
        this.$confirm("提示", "确定驳回吗？", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: 2
            };
            API.status_complain(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "发货成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.goodName) {
        params.bInfo = that.filters.goodName;
      }
      if (that.filters.userInfo) {
        params.fInfo = that.filters.userInfo;
      }
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.province && that.filters.province != null)
      {
        params.province = that.filters.province
      } else if (that.provinceList != null)
      {
        params.province = that.provinceList
      }
      
      if (that.filters.address) {
        params.otherInfo = that.filters.address;
      }
      that.tableDataLoading = true;
      API.complain_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.shop-pic1{
    width: 100%;
    /* display: flex;
    flex-wrap: wrap;
    justify-content: space-around; */
    height: 80vh;
    overflow: hidden;
    overflow-y: auto;
}
.shop-pic1 img {
  /* width: 49%; */
  width: 100%;
  height: auto;
  margin: 0 auto;
}
.main_content .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/complainList.vue